import * as actionTypes from 'actions';

const initialState = {
  cellGroups: [],
  loading: false
};

const cellGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FIND_CELL_GROUPS_PENDING: {
      return {
        ...state,
        loading: true
      };
    }

    /* The ws interceptor resolves failed requests, so the payload can be missing */
    case actionTypes.FIND_CELL_GROUPS_FULFILLED: {
      return {
        ...state,
        cellGroups: action.payload?.data?.result || initialState.cellGroups,
        loading: false
      };
    }

    default: {
      return state;
    }
  }
};

export default cellGroupsReducer;
